import { Button, Stack, Typography } from '@mui/material';
import { BaseDialog } from '@/components/shared/base-dialog';
import { useNotification } from '@/context/notification';
import { useRemoveDependent } from '@/data/collaborators/dependents';

interface RemoveDependentDialogProps {
  dependentId: number;
  onClose: () => void;
}

export const RemoveDependentDialog = ({
  dependentId,
  onClose,
}: RemoveDependentDialogProps) => {
  const { toast } = useNotification();
  const { mutate: removeDependent, isPending } = useRemoveDependent();

  const handleRemove = () => {
    removeDependent(dependentId, {
      onSuccess: () => {
        toast({
          content: 'Seu dependente foi removido com sucesso.',
          title: 'Dependente removido',
          type: 'success',
        });
      },
      onError: () => {
        toast({
          content: 'Erro ao remover dependente.',
          title: 'Erro',
          type: 'error',
        });
      },
    });
  };

  return (
    <BaseDialog
      onClose={onClose}
      open
      title="Remover dependente"
      actionsComponent={
        <>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            color="error"
            loading={isPending}
            onClick={handleRemove}
            type="submit"
            variant="contained"
          >
            Remover dependente
          </Button>
        </>
      }
    >
      <Stack spacing={2}>
        <Typography>
          Ao remover o dependente, ele não terá mais acesso à plataforma. Não se
          preocupe, seu dependente não perderá os descontos que já adquiriu.
        </Typography>
        <Typography>
          <strong>Tem certeza que deseja remover?</strong>
        </Typography>
      </Stack>
    </BaseDialog>
  );
};
